/* PB MOLTEN HEADINGS - one global system that BAKES liquid-chrome type over
   section headings. Config comes from window.PB_MOLTEN (theme settings, one
   panel for the whole store). For every .pb-molten-h / .pb-chrome heading:
   build TextGeometry from the heading's own text, render ONE frame on a shared
   offscreen renderer, copy it to a per-heading overlay canvas, then stop - no
   per-heading GPU loops. The real text stays in the DOM (SEO/a11y); it fades
   only after its bake lands. Re-bakes on resize/font-load. Design mode bakes
   immediately so the merchant sees changes live. */
(function () {
  if (window.__pbMoltenH) return; window.__pbMoltenH = 1;
  var CFG = window.PB_MOLTEN;
  if (!CFG || !CFG.enable) return;

  var SEL = 'h1.pb-molten-h, h2.pb-molten-h, h3.pb-molten-h, h1.pb-chrome, h2.pb-chrome, h3.pb-chrome';
  var EDITOR = !!(window.Shopify && Shopify.designMode);
  var engine = null, font = null, shared = null, queue = [], booting = false;

  function ensureEngine(cb) {
    if (engine && font) return cb();
    if (booting) { queue.push(cb); return; }
    booting = true; queue.push(cb);
    import(CFG.engine).then(function (T) {
      engine = T;
      new T.FontLoader().load(CFG.font, function (f) {
        font = f;
        queue.forEach(function (fn) { fn(); }); queue = [];
      });
    }).catch(function () { /* no WebGL/module support: plain headings remain */ });
  }

  function sharedRig(T) {
    if (shared) return shared;
    var renderer = new T.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    renderer.setPixelRatio(1); /* we size buffers explicitly per bake */
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = CFG.exp;

    function softPanel(w, h, b) {
      var g = new T.PlaneGeometry(w, h, 10, 10), pos = g.attributes.position, col = [];
      for (var i = 0; i < pos.count; i++) {
        var fx = 1 - Math.pow(Math.abs(pos.getX(i) / (w / 2)), 3);
        var fy = 1 - Math.pow(Math.abs(pos.getY(i) / (h / 2)), 3);
        var k = Math.max(0, fx * fy) * b;
        col.push(k, k, k * 1.02);
      }
      g.setAttribute('color', new T.Float32BufferAttribute(col, 3));
      return new T.Mesh(g, new T.MeshBasicMaterial({ vertexColors: true }));
    }
    function gradientWall(w, h, top, bottom) {
      var g = new T.PlaneGeometry(w, h, 1, 10), pos = g.attributes.position, col = [];
      for (var i = 0; i < pos.count; i++) {
        var k = (pos.getY(i) + h / 2) / h;
        var b = bottom + Math.pow(k, 1.6) * (top - bottom);
        col.push(b, b, b * 1.02);
      }
      g.setAttribute('color', new T.Float32BufferAttribute(col, 3));
      return new T.Mesh(g, new T.MeshBasicMaterial({ vertexColors: true }));
    }
    var env = new T.Scene();
    env.background = new T.Color(0x000000);
    env.add(new T.Mesh(new T.BoxGeometry(60, 60, 60),
      new T.MeshBasicMaterial({ color: new T.Color(CFG.shell, CFG.shell, CFG.shell * 1.05), side: T.BackSide })));
    var L = CFG.lights;
    function put(m, x, y, z, ry, rx) { m.position.set(x, y, z); m.rotation.y = ry; m.rotation.x = rx; env.add(m); }
    put(softPanel(40, 9, 7 * L), 0, 16, -6, 0, Math.PI / 2.6);
    put(softPanel(7, 30, 6 * L), -20, 2, 2, Math.PI / 2.4, 0);
    put(softPanel(5, 30, 4.5 * L), 21, 0, -2, -Math.PI / 2.5, 0);
    put(softPanel(46, 7, 3 * L), 0, -14, 8, 0, -Math.PI / 2.7);
    put(softPanel(16, 4, 3.5 * L), 0, 6, -24, 0, 0);
    put(gradientWall(44, 26, CFG.faceT, CFG.faceB), 0, 2, 26, Math.PI, 0);
    put(softPanel(30, 6, 4 * L), 0, 10, 22, Math.PI, Math.PI / 14);

    var scene = new T.Scene(); /* transparent */
    var pmrem = new T.PMREMGenerator(renderer);
    scene.environment = pmrem.fromScene(env, 0.035).texture;

    var material = new T.MeshPhysicalMaterial({
      color: 0xffffff, metalness: 1, roughness: CFG.rough,
      envMapIntensity: CFG.env, clearcoat: 1, clearcoatRoughness: 0.04
    });
    var camera = new T.PerspectiveCamera(30, 1, 0.1, 200);
    shared = { renderer: renderer, scene: scene, material: material, camera: camera, group: new T.Group() };
    scene.add(shared.group);
    return shared;
  }

  function bake(el) {
    var T = engine, rig = sharedRig(T);
    var text = (el.dataset.moltenText || el.textContent || '').replace(/\s+/g, ' ').trim();
    var r = el.getBoundingClientRect();
    if (!text || r.width < 8 || r.height < 8) return false;

    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    var W = Math.ceil(r.width * dpr), H = Math.ceil(Math.min(r.height * 1.5, r.height + 80) * dpr);

    /* geometry: molten cross-section - bevel meets mid-stroke, no flat face */
    var puff = CFG.puff;
    var geo = new T.TextGeometry(text, {
      font: font, size: 2.1, height: CFG.depth,
      curveSegments: 40, bevelEnabled: true,
      bevelThickness: puff * 2.4, bevelSize: puff,
      bevelOffset: -puff * 0.45, bevelSegments: 14
    });
    geo.computeBoundingBox();
    var bb = geo.boundingBox, tw = bb.max.x - bb.min.x, th = bb.max.y - bb.min.y;
    geo.deleteAttribute('normal'); geo.computeVertexNormals();
    var mesh = new T.Mesh(geo, rig.material);
    mesh.position.set(-bb.min.x - tw / 2, -bb.min.y - th / 2, 0);
    rig.group.clear(); rig.group.add(mesh);
    rig.group.rotation.set(CFG.tiltX, CFG.tiltY, 0);

    rig.renderer.setSize(W, H, false);
    rig.camera.aspect = W / H;
    /* fit: frame the text width AND height inside the canvas */
    var fitW = (tw / 2) / Math.tan((rig.camera.fov * Math.PI / 360)) / rig.camera.aspect;
    var fitH = (th / 2 + puff * 2.4) / Math.tan(rig.camera.fov * Math.PI / 360);
    rig.camera.position.set(0, 0, Math.max(fitW, fitH) * 1.12 + CFG.depth);
    rig.camera.updateProjectionMatrix();
    rig.renderer.render(rig.scene, rig.camera);

    var out = el.__pbmhCanvas;
    if (!out) {
      out = document.createElement('canvas');
      out.className = 'pbmh__bake';
      out.setAttribute('aria-hidden', 'true');
      out.style.cssText = 'position:absolute;left:0;right:0;pointer-events:none;z-index:1;';
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';
      el.appendChild(out);
      el.__pbmhCanvas = out;
    }
    out.width = W; out.height = H;
    out.style.top = (-(H / dpr - r.height) / 2) + 'px';
    out.style.width = (W / dpr) + 'px';
    out.style.height = (H / dpr) + 'px';
    /* honor the heading's text-align: the 3D text is centred in the canvas, so
       shift the overlay so the rendered word sits where the DOM text sat */
    var align = getComputedStyle(el).textAlign;
    var worldH = 2 * rig.camera.position.z * Math.tan(rig.camera.fov * Math.PI / 360);
    var pxPerWorld = H / worldH;
    var textPx = (tw * pxPerWorld) / dpr;
    if (align === 'left' || align === 'start') out.style.left = (-(W / dpr - textPx) / 2) + 'px';
    else if (align === 'right' || align === 'end') out.style.left = ((W / dpr - textPx) / 2) + 'px';
    else out.style.left = '0';
    out.getContext('2d').drawImage(rig.renderer.domElement, 0, 0);
    geo.dispose();
    el.classList.add('pbmh-baked');
    return true;
  }

  function bakeSoon(el) {
    ensureEngine(function () {
      /* fonts settled first so measurements are final */
      var go = function () { if (!bake(el)) setTimeout(function () { bake(el); }, 800); };
      (document.fonts && document.fonts.ready) ? document.fonts.ready.then(go) : go();
    });
  }

  function initAll() {
    document.querySelectorAll(SEL).forEach(function (el) {
      if (el.dataset.pbmhInit || el.closest('.pbm')) return;
      el.dataset.pbmhInit = '1';
      var r = el.getBoundingClientRect();
      if (EDITOR || (r.top < (window.innerHeight || 800) + 300 && r.bottom > -300)) bakeSoon(el);
      else if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) { bakeSoon(el); io.disconnect(); } });
        }, { rootMargin: '300px 0px' });
        io.observe(el);
      } else bakeSoon(el);
    });
  }

  var rT = null;
  addEventListener('resize', function () {
    clearTimeout(rT);
    rT = setTimeout(function () {
      document.querySelectorAll('.pbmh-baked').forEach(function (el) { bake(el); });
    }, 250);
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
  /* only when an added node is (or holds) a molten / chrome heading, not on every DOM change */
  new MutationObserver(function (recs) {
    for (var i = 0; i < recs.length; i++) {
      var a = recs[i].addedNodes;
      for (var j = 0; j < a.length; j++) { var n = a[j]; if (n.nodeType === 1 && (n.matches(SEL) || n.querySelector(SEL))) { initAll(); return; } }
    }
  }).observe(document.body || document.documentElement, { childList: true, subtree: true });
})();
